import { Form } from '@mairistem/composants';
import type { Mouvement } from '@mairistem/comptabilite';
import { Date } from '@mairistem/finances-utils';
import React from 'react';
import { onChangeDateDepart, onChangeDuree } from './delaiPaiementUtils';

interface DelaiPaiementProps {
	dateDepartDelaiGlobalPaiement?: string;
	dateFinDelaiGlobalPaiement?: string;
	dureeDelaiGlobalPaiement?: number;
	onChange: (
		data: Pick<
			Mouvement,
			| 'dateDepartDelaiGlobalPaiement'
			| 'dateFinDelaiGlobalPaiement'
			| 'dureeDelaiGlobalPaiement'
		>,
	) => void;
}

const DelaiPaiement = ({
	dateDepartDelaiGlobalPaiement,
	dateFinDelaiGlobalPaiement,
	dureeDelaiGlobalPaiement,
	onChange,
}: DelaiPaiementProps) => {
	const handleChangeDateDepart = (value: string) => {
		onChange({
			...onChangeDateDepart({
				dureeDelaiGlobalPaiement,
				dateDepartDelaiGlobalPaiement: value,
				dateFinDelaiGlobalPaiement,
			}),
		});
	};

	const handleDureeChange = (_e, { value }) => {
		onChange({
			...onChangeDuree({
				dureeDelaiGlobalPaiement: value,
				dateDepartDelaiGlobalPaiement,
				dateFinDelaiGlobalPaiement,
			}),
		});
	};

	const handleChangeDateFin = (value: string) => {
		onChange({ dateFinDelaiGlobalPaiement: value });
	};

	return (
		<>
			<Form.Group>
				<Form.Field
					control={Date}
					data-testid="dateDepartDelaiPaiement"
					fluid
					key="depart"
					label="Départ"
					name="dateDepartDelaiGlobalPaiement"
					onChange={handleChangeDateDepart}
					value={dateDepartDelaiGlobalPaiement}
					width={8}
				/>
				<Form.Input
					data-testid="delaiPaiement"
					label="Durée (en jours)"
					name="dureeDelaiGlobalPaiement"
					onChange={handleDureeChange}
					value={dureeDelaiGlobalPaiement}
					width={8}
				/>
			</Form.Group>
			<Form.Group>
				<Form.Field
					control={Date}
					data-testid="dateFinDelaiPaiement"
					fluid
					key="fin"
					label="Fin"
					name="dateFinDelaiGlobalPaiement"
					onChange={handleChangeDateFin}
					value={dateFinDelaiGlobalPaiement}
					width={8}
				/>
			</Form.Group>
		</>
	);
};

export default DelaiPaiement;
